import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import viewUtils from "../../utils/viewUtils";
import { useTranslation } from 'react-i18next'
import { Image, Typography, Pagination, Row, Col } from "antd";
import ErrorImage from '../../common/images/ErrorImage';

import {
  getCategoryApi,
  getArticlesApi,
} from "../../api/WebApi";

const CategoryPage = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const { category_id } = useParams();

  const [category, setCategory] = useState<any>();
  const [articles, setArticles] = useState<any>({data: [], totle: 0});
  const [filter, setFilter] = useState({ page: 1, page_size: 12});

  const handlePageChange = (page: number, per_page: number) => setFilter(data => ({ ...data, page: page, per_page: per_page }));

  useEffect(() => {
    if(!!category_id) {
      getCategoryApi(category_id).then((res) => {
        if(res.status) {
          setCategory(res.data)
        }
      })
    }
  }, [category_id])

  useEffect(() => {
    if(!!category_id) {
      getArticlesApi({
        category_id: category_id,
        page: filter?.page,
        page_size: filter?.page_size,
      }).then((res) => {
        if(res.status) {
          setArticles({
            data: res.data || [],
            totle: res.paginate?.total_entries || 0
          })
        }
      })
    }
  }, [category_id, filter])

  return (
    <div className='max-content' style={{ marginTop: '8vh', marginBottom: '10vh'}}>
      <Typography.Title className='page-title' style={{marginBottom: '1.5em'}}>
        { viewUtils.prettyWithLang(category?.name, i18n.language)}
      </Typography.Title>
      {
        (articles?.data || []).length > 0 && <>
          <Row gutter={[40, 20]}>
            {
              (articles?.data || []).map((article: any) => (
                <Col
                  xs={24} md={12} xl={8}
                  key={article.id}
                  className="article-card"
                  onClick={() => {
                    navigate(`/article/${article.id}`);
                  }}>
                  <div className='article-cover-div'>
                    <div className='cover-div'>
                      <Image
                        src={(viewUtils.prettyWithLang(article?.assets_url, i18n.language) || [])[0]}
                        fallback={ErrorImage}
                        preview={false}
                      />
                    </div>
                  </div>
                  <div style={{padding: '1em 0'}}>
                    <Typography.Paragraph className='title' ellipsis={{rows: 2}}>
                      {viewUtils.prettyWithLang(article?.name, i18n.language)}
                    </Typography.Paragraph>
                  </div>
                </Col>
              ))
            }
          </Row>
          <Pagination
            current={filter.page}
            pageSize={filter.page_size}
            total={articles.total}
            onChange={handlePageChange}
            showSizeChanger={false}
            hideOnSinglePage={true}
            style={{textAlign: 'right', justifyContent: 'flex-end', margin: '1em 0'}}
          />
        </>
      }
    </div>
  )
}

export default CategoryPage;